function humanizeSegment(segment) {
    const spaced = segment.replace(/([a-z0-9])([A-Z])/g, "$1 $2").replace(/[_-]+/g, " ").trim();
    return spaced.charAt(0).toUpperCase() + spaced.slice(1).toLowerCase();
}
/**
 * Resolves a business label for an OPQRY field.
 *
 * Order: the backend-supplied Tolgee key, then the legacy `filters.fields.<path>` key
 * (covers a field whose key shipped before its translation), then a humanized path as a
 * defensive default. vue-i18n echoes the key back when there is no translation, which is
 * what each step tests for.
 */
export function resolveFieldLabel(field, t) {
    if (field.labelKey) {
        const fromBackendKey = t(field.labelKey);
        if (fromBackendKey !== field.labelKey) {
            return fromBackendKey;
        }
    }
    const pathKey = `filters.fields.${field.path}`;
    const fromPathKey = t(pathKey);
    if (fromPathKey !== pathKey) {
        return fromPathKey;
    }
    return field.path.split(".").map(humanizeSegment).join(" · ");
}
